import { createSelector } from 'reselect';

const selectState = (state: any) => state.services.dialogs;

export const selectDialogs = createSelector([selectState], (state) => state?.dialogs ?? []);
